import CRMDashboard from '../pages/CRMDashboard';

const crmDashboardRoute = {
  public: [],
  auth: [
    {
      name: 'crm-dashboard',
      path: '/dashboard/crm',
      permissions: [
        'KASM',
        'KASOM',
        'KASROM',
        'KASH',
        'SAM',
        'RSM',
        'NSM-SPARTAN',
        'admin',
        'PM',
        'GPM',
        'COO',
        'EXECUTIVE',
      ],
      component: CRMDashboard,
    },
  ],
};

export default crmDashboardRoute;
